import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ArticleModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.ArticleModal = (function (_super) {
    __extends(ArticleModal, _super);
    
    EVENT: {
        ARTICLE_MODAL_READY: 'HSN.ArticleModal.ARTICLE_MODAL_READY'
    }

    /**
    * new HSN.ArticleModal()
    **/
    function ArticleModal() {
        this.elementName = '#';
        this.name = 'HSN.ArticleModal';

        return ArticleModal.__super__.constructor.call(this);
    }

    ArticleModal.prototype._hide = function () {
    };

    /**
    * HSN.ArticleModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ArticleModal.prototype._show = function (url, callback) {
        var __scope = this;

        $.ajax(url, {
            dataType: 'html',
            success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');
                data += '<div class="endOfModal" tabindex="0"></div>';
                __scope.DisplayModal(data, 0);

                if (callback)
                    callback();                

                $('#modalPopup').on('focus', function () {
                    $('.modal-content-container').focus();
                });                
                $('.endOfModal').on('focus', function () {
                    $('#closeModal').focus();
                });
                $('.endOfModal', __scope.Content).on('keydown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    __scope.Close.focus();
                });
            },
            error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    ArticleModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;
        
        this.Content.showHtml(data, time,
            function () {
                var elemetToFocus = __scope.Root.find('#modalPopup');  
                __scope.Center();
                __scope.Content.animate({ opacity: 1 }, function() {
                    __scope.SetFocus(elemetToFocus);                    
                });
            },
            function () {
                //__scope.Center();
            });
    };

    return ArticleModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/ArticleModal.js